(function handleAccordian(){
	if(typeof window.$ == 'undefined'){
		setTimeout(handleAccordian, 100);
		return;
	}

	$('#accordion .panel-heading').on('click', function(e){
		if ($(this).hasClass('expanded')) {
			$(this).siblings('.panel-collapse').slideUp();
			$(this).removeClass('expanded');
		}
		else {
			$(this).siblings('.panel-collapse').slideDown();
			$(this).addClass('expanded');
		}
		e.preventDefault();
		return false;
	});
})();